"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _hooks = require("../../../../../../../hooks");
var _CetComponentsProvider = require("../../../../../../../providers/CetComponentsProvider");
const useStyles = () => {
  const {
    pxToRem
  } = (0, _hooks.useStylesUtils)();
  const {
    themeColors
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const ccBookMyBooksToggleStyle = (0, _react.useMemo)(() => {
    const ccBookMyBooksToggle = (0, _css.css)({
      display: 'flex',
      background: 'transparent',
      border: 'none',
      alignItems: 'center',
      justifyContent: 'flex-end',
      borderRadius: pxToRem(7),
      height: pxToRem(15),
      padding: `0 ${pxToRem(5)}`,
      '&:hover': {
        cursor: 'pointer',
        backgroundColor: 'rgba(127, 127, 144, 0.25)'
      },
      span: {
        display: 'inline-block',
        width: pxToRem(4),
        height: pxToRem(4),
        backgroundColor: themeColors?.general.text,
        borderRadius: '50%',
        margin: `0 ${pxToRem(1)}`
      }
    });
    return {
      ccBookMyBooksToggle
    };
  }, [pxToRem, themeColors?.general.text]);
  return {
    'cc-Book__my-books-toggle': ccBookMyBooksToggleStyle.ccBookMyBooksToggle
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;